<template>
    <div class="mainpage">
        <div class="maincontain">
            <!-- 头部 -->
            <div class="qa-personal-header">
                <!-- <div class="intro-title">
                    <el-image :src="courseImg" class="title-icon" />
                    <div class="title-text"><span>互动问答-个人</span></div>
                </div> -->
                <el-button type="primary" class="publish-btn" @click="release">发布问题</el-button>
            </div>

            <!-- 筛选与搜索 -->
            <div class="qa-filter-bar">
                <div class="filter-tags">
                    <div class="filter-item" v-for="filter in filterList" :key="filter.type"
                        :class="{ active: queryParams.type === filter.type }" @click="changeType(filter.type)">
                        <span>{{ filter.label }}</span>
                        <span class="filter-count" v-if="filter.count !== undefined">({{ filter.count }})</span>
                    </div>
                </div>
                <div class="filter-search">
                    <el-select v-model="queryParams.belong_type" class="type-select" size="small" placeholder="我发表的问答">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                    <el-input class="search-input" v-model="queryParams.keyword" placeholder="请输入内容"
                        clearable></el-input>
                    <el-button type="primary" class="search-btn" @click="searchbt">查询</el-button>
                    <el-button class="bt-btn" @click="resetbt">重置</el-button>
                </div>
            </div>

            <!-- 列表 -->
            <div class="qa-list">
                <div class="qa-card" v-for="(item, index) in qadata" :key="index">
                    <div class="qa-card-main">
                        <el-image class="qa-avatar" :src="item.avatar">
                            <template slot="error">
                                <el-image :src="avater1"></el-image>
                            </template>
                        </el-image>
                        <div class="qa-content">
                            <div class="qa-user-line">
                                <span class="qa-username">{{ item.author_name }}</span>
                                <span class="qa-time">{{ item.created_at | dataformat }}</span>
                                <span v-if="Number(item.has_publish) === 0" class="qa-tag tag-pending">待审核</span>
                            </div>
                            <div class="qa-desc" @click="toreply(item)">
                                <div v-html="htmlDecode(item.content)"></div>
                            </div>
                        </div>
                        <div class="qa-stats" v-if="Number(item.has_publish) === 1">
                            <div class="stat-item">
                                <img class="stat-icon" :src="icon1" />
                                <span class="stat-num">{{ item.view_count }}</span>
                            </div>
                            <div class="stat-item" @click="setlikebt(item.id)">
                                <img class="stat-icon" :src="item.like_status == 1 ? icon5 : icon2" />
                                <span class="stat-num">{{ item.like_count }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-tip" v-if="qadata.length === 0">暂无数据</div>
            </div>

            <!-- 分页 -->
            <div class="elpagination">
                <div class="elpagination-title">共{{ total }}条</div>
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="10"
                    :current-page="queryParams.page" @current-change="pageChange"></el-pagination>
            </div>
        </div>
        <Customdialog ref="customdialog" title="发布问题" :appendtobody="true">
            <div slot="dialogbody" class="dialogbody qa-publish-body">
                <div class="publish-form-item">
                    <label class="publish-label">标题：</label>
                    <el-input class="publish-input" v-model="title" placeholder="请输入标题" clearable></el-input>
                </div>
                <div class="publish-form-item content-row">
                    <label class="publish-label">内容：</label>
                    <div class="publish-editor">
                        <Tinymce ref="editor" v-model="content" style="height: auto; border-radius: 8px"
                            @setInput="getValue">
                        </Tinymce>
                    </div>
                </div>
            </div>
            <div slot="dialogfooter" class="dialogfooter qa-publish-footer">
                <el-button class="cancel-btn" @click="canclebt">取消</el-button>
                <el-button type="primary" class="confirm-btn" @click="submitbt">确定</el-button>
            </div>
        </Customdialog>
    </div>
</template>

<script>
import { autoImgCorrection } from "@/utils/index"
import { getQaList, setQaLike, getQaAdd } from "@/api/qa"
import dayjs from "dayjs"
import Tinymce from "@/components/VueTinymce/index.vue"
import Customdialog from "@/components/customdialog.vue"
export default {
    name: "mainpage",
    components: { Customdialog, Tinymce },
    props: {
        course_semester_sn: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            qa_id: "",
            title: "",
            content: "",
            testimage: require("@/assets/test.png"),
            icon1: require("@/assets/course/UIout/QA/QA_ico_preview.png"),
            icon5: require("@/assets/course/UIout/QA/QA_ico_like.png"),
            icon2: require("@/assets/course/UIout/QA/QA_ico_like.png"),
            icon3: require("@/assets/评论_d.png"),
            del_d: require("@/assets/删除_d.png"),
            avater1: require("@/assets/course/UIout/QA/QA_ico_name.png"),
            courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),
            filterList: [
                { label: "全部", type: 0 },
                { label: "仅教师参与", type: 1 },
                { label: "回复最多", type: 2 },
            ],
            queryParams: {
                keyword: "",
                belong_type: 0,
                type: 0,
                related_type: 1,
                related_id: "",
                course_semester_sn: '',
                page: 1,
                per_page: 10
            },
            total: 0,
            options: [
                {
                    value: 0,
                    label: "全部讨论",
                },
                {
                    value: 1,
                    label: "我发表的问答",
                },
            ],
            qadata: [],
            iteminfo: {},
            loading: null,
        }
    },
    filters: {
        dataformat: function (value) {
            if (!value) return ""
            return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
        },
    },
    computed: {},
    created() {
        //console.log(this.$route.query)
        this.iteminfo = this.$route.query
        this.qa_id = this.course_semester_sn
        this.queryParams.course_semester_sn = this.qa_id
        this.getqalist()
    },
    methods: {
        toback() {
            this.$router.push({
                path: "/home/personalcenter/mainpage",
                query: {
                    id: 1,
                    componentId: "Mycourses",
                },
            })
        },
        release() {
            this.$refs.customdialog.dialogopenbt()
            this.content = ""
            this.title = ""
        },
        toreply(item) {
            // let obj = JSON.stringify(item);
            // let obj2 = JSON.stringify(this.iteminfo);
            this.$router.push({
                path: "/home/personalcenter/courseinteractiveqadetails",
                query: {
                    id: item.id,
                    // item: encodeURIComponent(obj),
                    // iteminfo: encodeURIComponent(obj2),
                },
            })
        },
        releasebt() {
            this.$refs.customdialog.dialogopenbt()
        },
        canclebt() {
            this.$refs.customdialog.dialogclosebt()
        },
        searchbt() {
            this.getqalist()
        },
        resetbt() {
            this.queryParams.keyword = ""
            this.queryParams.belong_type = 0
            this.queryParams.type = 0
            this.getqalist()
        },
        changeType(type) {
            this.queryParams.type = type
            this.queryParams.page = 1
            this.getqalist()
        },
        setlikebt(id) {
            this.loading = this.$loading({
                lock: true,
                text: "",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.4)",
                customClass: 'setlike-loading',
            })
            this.setQaLike({ id: id })
        },
        submitbt() {
            if (this.title === "") {
                this.$message.warning("请输入标题")
                return false
            } else if (this.content === "") {
                this.$message.warning("请输入内容")
                return false
            }
            this.QaAdd({
                title: this.title,
                related_type: 1,
                related_id: "",
                course_semester_sn: this.qa_id,
                content: this.content,
            })
        },
        QaAdd(params) {
            getQaAdd(params)
                .then((response) => {
                    if (response.code === 0) {
                        this.$refs.customdialog.dialogclosebt()
                        this.loading = this.$loading({
                            lock: true,
                            text: "",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.4)",
                            customClass: 'setlike-loading',
                        })
                        setTimeout(() => {
                            this.getqalist()
                        }, 1500)
                    }
                })
                .catch((error) => {
                    //console.log(error)
                })
        },
        async getqalist() {
            this.qadata = []
            await getQaList(this.queryParams)
                .then((response) => {
                    if (response.data.data && response.data.data.length > 0) {
                        let resData = response.data.data
                        // if (resData && resData.length > 0) {
                        //   resData.forEach(item => {
                        //     item.content = autoImgCorrection(item.content)
                        //   })
                        // }
                        this.qadata = resData
                        this.total = response.data.total
                    }
                    if (this.loading) {
                        this.loading.close()
                    }
                })
                .catch((error) => {
                    if (this.loading) {
                        this.loading.close()
                    }
                })
        },
        pageChange(val) {
            this.queryParams.page = val
            this.getqalist()
        },
        setQaLike(params) {
            setQaLike(params)
                .then((response) => {
                    if (response.code === 0) {
                        setTimeout(() => {
                            this.getqalist()
                        }, 1500)
                    }
                })
                .catch((error) => {
                    //console.log(error)
                })
        },
        // 获取富文本得值
        getValue(data) {
            this.content = data
        },
        htmlDecode(text) {
            const that = this
            if (text) {
                let textContent = text.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/\\/g, '');
                textContent.replace(/<img.+?>/ig, function (matchImg, captureImg) {
                    let resImgSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
                    text = textContent.replace(matchImg, resImgSrc)
                })
                textContent.replace(/<video(([\s\S])*?)<\/video>/gi, function (matchImg, captureImg) {
                    let resVideoSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
                    text = textContent.replace(matchImg, resVideoSrc)
                })
                textContent.replace(/<p>([^<]*?)<\/p>/gi, function (matchImg) {
                    let resPSrc = matchImg.replace(/<p>([^<]*?)<\/p>/gi, '$1').replace(/\\/g, '') // 自定义变量接收图片
                    text = textContent.replace(matchImg, resPSrc)
                })
            }
            return text
        },
    },
};
</script>
<style scoped lang="scss">
.mainpage {
    // background-color: #f8f8ff;
    // min-height: calc(100vh - 240px);
    // padding: 20px;

    .maincontain {
        background: #ffffff;
        border-radius: 16px;
        padding: 30px;
        // box-shadow: 0 2px 12px rgba(106, 90, 249, 0.06);

        .qa-personal-header {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 24px;

            .intro-title {
                display: flex;
                align-items: center;
                gap: 10px;

                .title-icon {
                    width: 36px;
                    height: 36px;
                }

                .title-text {
                    font-size: 20px;
                    font-weight: 600;
                    color: #333333;
                }
            }

            .publish-btn {
                background: #6a5af9;
                border-color: #6a5af9;
                border-radius: 20px;
                padding: 9px 24px;

                &:hover {
                    background: #7b6cfa;
                    border-color: #7b6cfa;
                }
            }
        }

        .qa-filter-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px;
            margin-bottom: 24px;

            .filter-tags {
                display: flex;
                align-items: center;
                gap: 12px;
                flex-wrap: wrap;

                .filter-item {
                    padding: 8px 18px;
                    background: #ffffff;
                    border: 1px solid #e0e0e0;
                    border-radius: 20px;
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                    user-select: none;
                    transition: all 0.3s;

                    &:hover {
                        color: #6a5af9;
                        border-color: #6a5af9;
                    }

                    &.active {
                        background: rgba(106, 90, 249, 0.1);
                        border-color: #6a5af9;
                        color: #6a5af9;
                    }

                    .filter-count {
                        margin-left: 4px;
                        font-size: 13px;
                    }
                }
            }

            .filter-search {
                display: flex;
                align-items: center;
                gap: 10px;
                flex-wrap: wrap;

                .type-select {
                    width: 130px;

                    ::v-deep .el-input__inner {
                        border-radius: 20px;
                        height: 40px;
                        line-height: 40px;
                    }
                }

                .search-input {
                    width: 220px;

                    ::v-deep .el-input__inner {
                        border-radius: 20px;
                        height: 40px;
                        line-height: 40px;
                    }
                }

                .search-btn {
                    background: #6a5af9;
                    border-color: #6a5af9;
                    border-radius: 20px;
                    width: 100px;

                    &:hover {
                        background: #7b6cfa;
                        border-color: #7b6cfa;
                    }
                }

                .bt-btn {
                    border-radius: 20px;
                    color: #666666;
                    border-color: #dcdcdc;
                    width: 100px;
                    margin-left: 0;

                    &:hover {
                        color: #6a5af9;
                        border-color: #6a5af9;
                    }
                }
            }
        }

        .qa-list {
            .qa-card {
                margin-bottom: 16px;
                padding: 20px;
                background: rgba(248, 247, 255, 0.6);
                border: 1px solid #edeaff;
                border-radius: 16px;
                transition: all 0.3s;

                &:hover {
                    box-shadow: 0 4px 16px rgba(106, 90, 249, 0.08);
                }

                .qa-card-main {
                    display: flex;
                    gap: 14px;

                    .qa-avatar {
                        width: 44px;
                        height: 44px;
                        flex-shrink: 0;
                        border-radius: 50%;
                        overflow: hidden;

                        ::v-deep img {
                            border-radius: 50%;
                            object-fit: cover;
                        }
                    }

                    .qa-content {
                        flex: 1;
                        min-width: 0;

                        .qa-user-line {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-bottom: 10px;

                            .qa-username {
                                font-size: 15px;
                                font-weight: 600;
                                color: #333333;
                            }

                            .qa-time {
                                font-size: 13px;
                                color: #999999;
                            }

                            .qa-tag {
                                padding: 2px 8px;
                                font-size: 12px;
                                border-radius: 4px;

                                &.tag-pending {
                                    color: #f13218;
                                    background: rgba(241, 50, 24, 0.1);
                                    border: 1px solid #f13218;
                                }
                            }
                        }

                        .qa-desc {
                            font-size: 14px;
                            color: #555555;
                            line-height: 1.8;
                            word-break: break-word;
                            word-wrap: break-word;
                            cursor: pointer;

                            ::v-deep p {
                                margin: 0 0 6px 0;
                            }

                            ::v-deep img {
                                max-width: 100%;
                                height: auto;
                            }
                        }
                    }

                    .qa-stats {
                        width: 90px;
                        flex-shrink: 0;
                        display: flex;
                        // flex-direction: column;
                        align-items: flex-end;
                        gap: 12px;

                        .stat-item {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            cursor: pointer;

                            .stat-icon {
                                width: 18px;
                                height: 18px;
                            }

                            .stat-num {
                                font-size: 13px;
                                color: #999999;
                            }

                            &:hover .stat-num {
                                color: #6a5af9;
                            }
                        }
                    }
                }
            }

            .empty-tip {
                text-align: center;
                padding: 60px 0;
                font-size: 14px;
                color: #999999;
            }
        }

        .elpagination {
            margin-top: 30px;
            display: flex;
            justify-content: center;
            align-items: center;

            .elpagination-title {
                margin-right: 10px;
                font-size: 14px;
                color: #666666;
            }
        }
    }


}

.dialogbody {
    padding: 20px;
    overflow: hidden;
    padding-bottom: 0px;

    &.qa-publish-body {
        // padding: 30px;
        overflow: visible;

        .publish-form-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            // padding: 20px;

            &.content-row {
                align-items: flex-start;

                .publish-label {
                    margin-top: 10px;
                }
            }

            .publish-label {
                width: 50px;
                flex-shrink: 0;
                font-size: 14px;
                color: #666666;
                text-align: right;
                margin-right: 12px;
            }

            .publish-input {
                flex: 1;

                ::v-deep .el-input__inner {
                    border-radius: 8px;
                    height: 42px;
                    line-height: 42px;
                    border-color: #d9d6ff;
                    background: #f8f8ff;

                    &:focus {
                        border-color: #6a5af9;
                    }
                }
            }

            .publish-editor {
                flex: 1;
                min-height: 220px;
                border: 1px solid #d9d6ff;
                border-radius: 8px;
                overflow: hidden;
                background: #f8f8ff;

                ::v-deep .tox-tinymce {
                    border: none;
                    border-radius: 8px;
                }
            }
        }
    }

    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        span {
            flex-shrink: 0;
            font-size: 14px;
            color: #666666;
        }

        .elinput {
            flex: 1;
            margin-left: 10px;

            ::v-deep .el-input__inner {
                border-radius: 8px;
            }
        }
    }

    .interactiveqa_content {
        width: 60px;
        float: left;
        font-size: 14px;
        color: #666666;
    }

    .interactiveqa_edit {
        width: calc(100% - 60px);
        float: left;
    }
}

.dialogfooter {
    padding-right: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 20px;

    .bt {
        margin-right: 20px;
        width: 64px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #cccccc;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        user-select: none;
        cursor: pointer;
    }

    .btactive {
        background: #6a5af9;
        color: white;
        border: 1px solid #6a5af9;
    }

    &.qa-publish-footer {
        padding-right: 30px;
        padding-bottom: 10px;
        gap: 12px;

        .cancel-btn {
            border-radius: 20px;
            padding: 9px 26px;
            color: #666666;
            border-color: #dcdcdc;

            &:hover {
                color: #6a5af9;
                border-color: #6a5af9;
            }
        }

        .confirm-btn {
            border-radius: 20px;
            padding: 9px 26px;
            background: #6a5af9;
            border-color: #6a5af9;

            &:hover {
                background: #7b6cfa;
                border-color: #7b6cfa;
            }
        }
    }
}

.qa-publish-dialog {
    padding: 20px;
}

/* 响应式 */
@media screen and (max-width: 1200px) {
    .mainpage {
        .maincontain {
            .qa-filter-bar {
                .filter-search {
                    .search-input {
                        width: 180px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .mainpage {
        padding: 10px;

        .maincontain {
            padding: 20px;

            .qa-personal-header {
                .publish-btn {
                    padding: 7px 18px;
                    font-size: 13px;
                }
            }

            .qa-filter-bar {
                flex-direction: column;
                align-items: flex-start;
                gap: 12px;

                .filter-tags {
                    flex-wrap: wrap;
                    gap: 8px;

                    .filter-item {
                        padding: 6px 12px;
                        font-size: 13px;
                    }
                }

                .filter-search {
                    width: 100%;
                    flex-wrap: wrap;

                    .type-select {
                        width: 100%;
                    }

                    .search-input {
                        flex: 1;
                        width: auto;
                        min-width: 120px;
                    }
                }
            }

            .qa-list {
                .qa-card {
                    padding: 12px;

                    .qa-card-main {
                        flex-wrap: wrap;

                        .qa-avatar {
                            width: 36px;
                            height: 36px;
                        }

                        .qa-content {
                            .qa-user-line {
                                .qa-username {
                                    font-size: 14px;
                                }

                                .qa-time {
                                    font-size: 12px;
                                }
                            }

                            .qa-desc {
                                font-size: 13px;
                                line-height: 22px;
                            }
                        }

                        .qa-stats {
                            width: 100%;
                            flex-direction: row;
                            justify-content: flex-start;
                            margin-top: 10px;
                            padding-left: 50px;

                            .stat-item {
                                .stat-icon {
                                    width: 16px;
                                    height: 16px;
                                }

                                .stat-num {
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
            }

            .elpagination {
                margin-top: 24px;
                flex-wrap: wrap;
                gap: 8px;

                .elpagination-title {
                    font-size: 13px;
                    width: 100%;
                    text-align: center;
                    margin-right: 0;
                    margin-bottom: 4px;
                }

                ::v-deep .el-pagination {
                    .btn-prev,
                    .btn-next,
                    .el-pager li {
                        min-width: 30px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 480px) {
    .mainpage {
        .maincontain {
            padding: 12px;

            .qa-personal-header {
                .publish-btn {
                    padding: 6px 14px;
                    font-size: 12px;
                }
            }

            .qa-filter-bar {
                .filter-tags {
                    .filter-item {
                        padding: 5px 10px;
                        font-size: 12px;
                    }
                }

                .filter-search {
                    flex-direction: column;

                    .type-select,
                    .search-input,
                    .search-btn,
                    .reset-btn {
                        width: 100%;
                    }
                }
            }

            .qa-list {
                .qa-card {
                    padding: 10px;

                    .qa-card-main {
                        .qa-avatar {
                            width: 32px;
                            height: 32px;
                        }

                        .qa-content {
                            .qa-user-line {
                                .qa-username {
                                    font-size: 13px;
                                }
                            }

                            .qa-desc {
                                font-size: 12px;
                                line-height: 20px;
                            }
                        }

                        .qa-stats {
                            padding-left: 42px;
                        }
                    }
                }
            }
        }
    }
}
</style>
